import React, { useEffect, useState } from 'react'
import {
	ProcessingNote,
	ProcessingWrap,
	StepActiveDot,
	StepBullet,
	StepLabel,
	StepRow,
	StepsList,
} from '../ItineraryImportPage.styles'
import { computeStepIndex, processingStepTitles } from '../constants'
import { Check } from './icons'
import OrbitLoader from './OrbitLoader'

interface ProcessingBodyProps {
	startedAt: number | null
	fileCount: number
}

const ProcessingBody: React.FC<ProcessingBodyProps> = ({ startedAt, fileCount }) => {
	const [now, setNow] = useState(() => Date.now())
	useEffect(() => {
		const id = window.setInterval(() => setNow(Date.now()), 500)
		return () => window.clearInterval(id)
	}, [])

	const elapsedMs = startedAt ? now - startedAt : 0
	const stepIndex = computeStepIndex(elapsedMs)

	return (
		<ProcessingWrap>
			<OrbitLoader size={104} />
			<StepsList>
				{processingStepTitles(fileCount).map((title, i) => {
					const done = i < stepIndex
					const active = i === stepIndex
					const opacity = i > stepIndex ? 0.45 : 1
					return (
						<StepRow key={title} $opacity={opacity}>
							<StepBullet $state={done ? 'done' : active ? 'active' : 'pending'}>
								{done ? <Check size={12} /> : active ? <StepActiveDot /> : null}
							</StepBullet>
							<StepLabel>{title}</StepLabel>
						</StepRow>
					)
				})}
			</StepsList>
			<ProcessingNote>This usually takes 15–90 seconds.</ProcessingNote>
		</ProcessingWrap>
	)
}

export default ProcessingBody
